import {
  InputAdornment,
  makeStyles,
  MenuItem,
  TextField,
  Typography,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import i18n from 'i18n';
import React from 'react';
import { getDefaultAvailableOperators, SelectedFilter } from 'utils/filters';
import ConditionOperatorSelect from '../ConditionOperatorSelect';
import styles from './styles';

interface Props {
  filter: SelectedFilter;
  onDeleteFilter: (filter: SelectedFilter) => void;
  onUpdateFilter: (filter: SelectedFilter) => void;
  onEnterPress: () => void;
}

const SingleFilter = ({
  filter,
  onDeleteFilter,
  onUpdateFilter,
  onEnterPress,
}: Props) => {
  const classes = makeStyles(styles)();

  return (
    <TextField
      autoFocus
      id={filter.field}
      className={classes.textField}
      fullWidth
      variant="outlined"
      value={filter.value || ''}
      label={i18n.t(filter.label)}
      select={filter.isSelect}
      onChange={e => onUpdateFilter({ ...filter, value: e.target.value })}
      onKeyPress={e => e.key === 'Enter' && onEnterPress()}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <ConditionOperatorSelect
              options={
                filter.availableOperators ||
                getDefaultAvailableOperators(filter)
              }
              value={filter.operator}
              onChange={operator => onUpdateFilter({ ...filter, operator })}
            />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end" onClick={() => onDeleteFilter(filter)}>
            <Close className={classes.closeIcon} />
          </InputAdornment>
        ),
      }}
    >
      {filter.isSelect &&
        filter.selectOptions?.map((option, index) => (
          <MenuItem
            key={`${filter.field}-${option.value}-${index}`}
            value={option.value}
          >
            <Typography className={classes.smallFontSize}>
              {i18n.t(option.label)}
            </Typography>
          </MenuItem>
        ))}
    </TextField>
  );
};

export default SingleFilter;
